<template lang="html">
  <div id="d-page-template-1">

    <section class="search-section-s1">
      <b-form @submit="onSubmit">
        <b-form-group class="form-group-s1">
          <b-form-input
          v-model="formSearch.keywords"
          type="text"
          placeholder="Buscar..."
          required
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" class="btn-search">
          <i class="far fa-search"></i>
        </b-button>
      </b-form>
    </section>

    <section class="short-info-section-s1">
      <div class="box-top">
        <div class="col-12 col-title">
          <h2 class="txt-breadcrumb">
            <span>Bolsa de Trabajo</span>
            Detalle de Gerente de Sucursal
          </h2>
        </div>
      </div>
    </section>

    <section class="requests-section">
      <div class="box-results">

        <div class="card">
          <div class="tabs">
            <div class="tab-content">
              <div class="post-template-s5 w-extra detail-page">
                <div class="box-extra-content">
                  <div class="box-bubbles">
                    <span class="bubble green">Postulado</span>
                  </div>

                  <div class="box-txt">
                    <span class="date">12/MAYO/2023</span>
                  </div>
                </div>

                <div class="box-main-content">
                  <div class="box-top">
                    <div class="col col-title">
                      <h5 class="title">Gerente de sucursal</h5>
                    </div>

                    <div class="col col-posted">
                      <h6 class="date">Publicado 20-Mar-2023</h6>
                    </div>

                    <div class="col-12 col-location">
                      <h5 class="subtitle">Colima, Colima.</h5>
                      <div class="box-bubbles">
                        <span class="bubble">Presencial</span>
                      </div>
                    </div>
                  </div>

                  <div class="box-info">
                    <h6 class="date">
                      <span class="days">Lun - Vie</span>
                      <span class="hour">10am - 9pm</span>
                    </h6>

                    <div class="mt-3 box-long-descr">
                      <h5 class="box-title">Descripción del puesto:</h5>
                      <div class="descr">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                        </p>
                      </div>
                    </div>

                    <div class="mt-4 box-long-descr">
                      <h5 class="box-title">Requisitos:</h5>
                      <div class="descr">
                        <ul>
                          <li>Architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui </li>
                          <li>Ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.</li>
                          <li>Et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam</li>
                          <li>Sed quia non numquam eius modi tempora incidunt ut labore.</li>
                          <li>Quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut.</li>
                          <li>Aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur.</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="box-actions">
                    <a class="btn btn-s1 bg-red btn-apply">Postularme</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      formSearch: {
        keywords: null
      },
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
    },
  }
}
</script>
